import $ from 'jquery';
import { Autoplay, Navigation, Swiper } from 'swiper';

import { $Elements, BrowserEvents, TransitionDurations, Breakpoints, Classes, Elements } from './constants';

Swiper.use([Autoplay, Navigation]);

$Elements.document.on(BrowserEvents.page.enter, () => {

	// ---------- Carousel ----------

	$('.content-section .section-carousel, .content-section .column-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: TransitionDurations.default,
				loop: true,
				observer: true,
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Slideshow ----------

	$('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: TransitionDurations.default,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- List ----------

	$('.sublist-toggle').each(function(e) {

		$(this).click(function(e) {

			const sublist = this.nextElementSibling;
			const depth = this.dataset.sublist;

			if(window.innerWidth < Breakpoints.mobile) {

				 if(depth && depth === '1') {

				 	if(sublist && sublist.classList.contains('first-sublist')) {
					    Elements.ListWrapper.classList.add(Classes.firstSublistOpen);
					    sublist.classList.add(Classes.active);
				    }
				    else {

					    $Elements.ListWrapper.removeClass(Classes.firstSublistOpen);
					    $Elements.ListWrapper.find('.first-sublist').removeClass(Classes.active);
				    }
				 }

				if(depth && depth === '2') {

					if( sublist && sublist.classList.contains('second-sublist')) {
						Elements.ListWrapper.classList.add(Classes.secondSublistOpen);
						sublist.classList.add(Classes.active);
					}
					else {
						$Elements.ListWrapper.removeClass(Classes.secondSublistOpen);
						$Elements.ListWrapper.find('.second-sublist').removeClass(Classes.active);
					}
				}
			}

			else {

				const activeFirstList = Elements.ListWrapper.querySelector('.first-sublist.active');
				const activeSecondList = Elements.ListWrapper.querySelector('.second-sublist.active');

				if(sublist && depth && depth === '1') {

					if(activeFirstList && !activeFirstList.isSameNode(sublist)) {
						activeFirstList.classList.remove(Classes.active);
						activeFirstList.parentElement.classList.remove(Classes.active);
						sublist.classList.add(Classes.active);
						sublist.parentElement.classList.add(Classes.active);
					}
					else if(activeFirstList && activeFirstList.isSameNode(sublist)) {
						sublist.classList.remove(Classes.active);
						sublist.parentElement.classList.remove(Classes.active);
					}
					else {
						sublist.classList.add(Classes.active);
						sublist.parentElement.classList.add(Classes.active);
					}
				}

				if(sublist && depth && depth === '2') {

					if(activeSecondList && !activeSecondList.isSameNode(sublist)) {
						activeSecondList.classList.remove(Classes.active);
						activeSecondList.parentElement.classList.remove(Classes.active);
						sublist.classList.add(Classes.active);
						sublist.parentElement.classList.add(Classes.active);
					}
					else if(activeSecondList && activeSecondList.isSameNode(sublist)) {
						sublist.classList.remove(Classes.active);
						sublist.parentElement.classList.remove(Classes.active);
					}
					else {
						sublist.classList.add(Classes.active);
						sublist.parentElement.classList.add(Classes.active);
					}
				}
			}
		});
	});
});
